const t = {
  name: "Latvia",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6C16 5.44772 16.4477 5 17 5C17.5523 5 18 5.44772 18 6Z" fill="currentColor"/>
<path d="M12 19H16C18.7623 19 21 16.7623 21 14V7H23V5H20.9001C20.437 2.71722 18.4198 1 16 1C14.6217 1 13.3736 1.56465 12.4678 2.45803L12.458 2.46779C11.5647 3.37357 11 4.62167 11 6V9.66677L1.6001 22.2L3.2001 23.4L6.50008 19H10V23H16V21H12V19ZM16 3C17.6577 3 19 4.34228 19 6V9.9991C18.1644 9.37169 17.1258 9 16 9H13V6C13 5.18076 13.3334 4.43087 13.8771 3.87713C14.4309 3.33337 15.1808 3 16 3ZM19 14C19 15.6577 17.6577 17 16 17H8.00008L12.5001 11H16C17.6577 11 19 12.3423 19 14Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Latvia
};
